
























































import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import SzTypes from "../../data/SzTypes";

@Component({})
export default class envDayAccount extends Vue {
    @Prop({ type: [Object, Array] })
    data: any;

    myData: any = this.data;
    totalAmount: number = +this.myData.pay + +this.myData.income;
    amountArr: Array<any> = [];
    szTypes = SzTypes.list;

    mounted() {
        this.fitMoney();
    }

    @Watch("data")
    dataChange(val: boolean) {
        this.myData = val;
        this.totalAmount = +this.myData.pay + +this.myData.income;
        this.fitMoney();
    }

    arrayRemove(arr: any[], v: string) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i] === v) {
                arr.splice(i, 1);
                break;
            }
        }
    }

    fitMoney() {
        this.amountArr = new Array(11);
        if (this.totalAmount != 0) {
            let arr = String(this.totalAmount).split("").reverse(), j, hasDot = arr.indexOf(".");
            if (arr.indexOf("-") != -1) {
                this.arrayRemove(arr, "-");
            }
            if (hasDot == -1) {
                j = 8;
                this.amountArr[9] = "0";
                this.amountArr[10] = "0";
            } else {
                j = 10;
                this.arrayRemove(arr, ".");
            }
            for (var i = 0; i < arr.length; i++) {
                this.amountArr[j] = arr[i];
                j--;
            }
        } else {
            this.amountArr = new Array(11)
        }
    };
}
